import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueCookies from 'vue-cookies'
import { i18n } from './plugins/i18n'
import './assets/scss/hud.scss'
import 'vue2-animate/dist/vue2-animate.min.css'
import IconBan from './components/IconBan'
import ArrowNext from './components/ArrowNext'
import ArrowPrev from './components/ArrowPrev'
import ButtonDownload from './components/ButtonDownload'
import ButtonBack from './components/ButtonBack'
import DataScreen from './components/DataScreen'
import Bar from './components/Bar'
import ScrollTitle from './components/ScrollTitle'



Vue.config.productionTip = false

Vue.use(VueCookies)
Vue.component('icon-ban', IconBan)
Vue.component('next', ArrowNext)
Vue.component('prev', ArrowPrev)
Vue.component('download', ButtonDownload)
Vue.component('back', ButtonBack)
Vue.component('data-screen', DataScreen)
Vue.component('bar', Bar)
Vue.component('scroll-title', ScrollTitle)




Vue.prototype.$appServer = 'http://hud.tropa.mx'
Vue.prototype.$shareUrls = {
  facebook: 'https://www.facebook.com/sharer/sharer.php',
  twitter: 'https://www.twitter.com/share',
  whatsapp: 'https://api.whatsapp.com/send'
}

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
